import sharedStyles from 'styles/css/SharedStyles.module.scss';
import formStyles from 'styles/css/FormStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleChangeDataPagesVisitRequest } from "reduxx/actions/pages/user/visitReq";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import { VISIT_REQUEST } from 'apis';
import apiRequest from 'utils/apiRequest';

const VisitRequest = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.login);
    const { doctorType, description } = useSelector(state => state.visitReq);

    const handleDoctorType = (type) => {
    	dispatch(handleChangeDataPagesVisitRequest('doctorType', type));
    };

    const handelChangeInputs = (event) => {
        const {name, value} = event.target;

        dispatch(handleChangeDataPagesVisitRequest(name, value));
    };

    const handleSubmitForm = () => {
    	if(description.trim().length === 0)
    		dispatch(handleSetOpenCustomSnackbar(true, {message: 'لطفا شرح مختصری از وضعیت خود بنویسید', severity: 'error', vertical: 'top', horizontal: 'right'}));
    	else {
    		apiRequest({
                dispatch,
                endpoint: VISIT_REQUEST,
                method: 'post',
                data: { doctorType, description },
                token: token,
                // successMessage: 'درخواست شما با موفقیت ثبت شد',
                onSuccess: (res) => {
                	dispatch(handleChangeDataPagesVisitRequest('doctorType', 1));
                	dispatch(handleChangeDataPagesVisitRequest('description', ''));

                    // if(profile.medicalRecords.hasSpecialDisease === null)
                    //     navigate('/medical-record');
                    // else if(profile.medicalRecords.hasSpecialMedication === null)
                    //     navigate('/medical-record2');
                    // else if(profile.medicalRecords.hasDrugAllergy === null)
                    //     navigate('/medical-record3');
                    // else if(profile.medicalRecords.insurance === null || profile.nationalCode === null)
                    //     navigate('/medical-record4');
                    // else
                        // navigate(`success`);

                    window.open(res.payLink + `&token=${token}`, "_self");
                }
            });
    	}
    };

    return (
        
        <div className={sharedStyles.container}>

        	<div className={[sharedStyles['container-padding'], sharedStyles['pb-24']].join(' ')}>
        		<ShortHeaderWithBackBtn />
        		
	            <div className={formStyles.title}>نوع پزشک مورد نظر جهت مشاوره را انتخاب فرمایید</div>
				<div className={formStyles.priceOptions}>
					<button onClick={() => handleDoctorType(1)} className={`${formStyles.priceButton} ${doctorType === 1 ? formStyles.active : ''}`}>پزشک عمومی <br /> 230,000 ت</button>
					<button onClick={() => handleDoctorType(2)} className={`${formStyles.priceButton} ${doctorType === 2 ? formStyles.active : ''}`}>متخصص <br /> 320,000 ت</button>
					<button onClick={() => handleDoctorType(3)} className={`${formStyles.priceButton} ${doctorType === 3 ? formStyles.active : ''}`}>فوق تخصص <br /> 385,000 ت</button>
				</div>
				<div className={formStyles.title}>شرح مختصری از درخواست خود را برای پزشک بنویسید:</div>
				<textarea name="description" value={description} onChange={handelChangeInputs} className={formStyles.descriptionBox} placeholder="..." />
				<button onClick={handleSubmitForm} className={formStyles.button}>پرداخت و ثبت درخواست</button>
				<div className={formStyles.note}>
					• تعرفه ویزیت، براساس تعرفه آزاد (طبق مصوبه هیأت محترم دولت در سال ۱۴۰۴) می‌باشد، ولی متقاضی دریافت کننده خدمت (بیمار)، هنگام مراجعه به داروخانه و یا مراکز پاراکلینیک (آزمایشگاه، مراکز تصویربرداری و سونوگرافی، مراکز فیزیوتراپی و ... ) میتواند از حق  بیمه‌ی خود (بصورت کامل طبق قوانین بیمه) استفاده کند.
				</div>
                <div className={formStyles.note}>
                    • پس از پرداخت و ثبت موفق درخواست، پزشکان نخبه دکتر بیست (Dr20) در اسرع وقت با شما تماس خواهند گرفت.
                </div>
                <div className={formStyles.note}>
                    • در صورت نیاز میتوانید با پشتیبانی دکتر بیست به شماره <a href="https://wa.me/+989020843320" className={formStyles['link-normal']}>09020843320</a> از طریق  واتس‌اپ  ارتباط برقرار کنید.
                </div>
        	</div>

		</div>

    );
}

export default VisitRequest;